import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import formatter from '../../../../common/helpers/formatter';
import type { Fax } from '../../../../common/types/client';
import type { Form } from '../../../../common/types/form';

type Props = {
  fax: Fax;
  itemForm: Form<Fax>;
};

function FaxRow({ fax, itemForm }: Props) {
  const policeStationOptions = formatter.getFieldSelectOptions('policeStation', itemForm.fields);
  const sentFromOptions = formatter.getFieldSelectOptions('sentFrom', itemForm.fields);

  const policeStationLabel = formatter.getOptionLabel(policeStationOptions, fax.policeStation);
  const sentFromLabel = formatter.getOptionLabel(sentFromOptions, fax.sentFrom);

  return (
    <Stack flex={1} direction='row' spacing={2} justifyContent='flex-start' alignItems='center'>
      <Typography alignSelf='flex-start'>{formatter.formatGermanDate(fax.date)}</Typography>
      <Link href={fax.documentLink} target='_blank'>
        {policeStationLabel} - {sentFromLabel}
      </Link>
    </Stack>
  );
}

export default FaxRow;
